import ApiClient from "@/shared/apiClient"

const baseUrl = import.meta.env.VITE_API_BASE_URL as string
const api = new ApiClient(baseUrl)

export default api
